export default "__VITE_ASSET__DHSrBecY__"